<template>
    <div class="p-2">
        
        <div
            class="card"
        >
            <div class="card-header">
                <h1>物種匯入</h1>
                <input type="file"
                @input="inputHandle">
                
            </div>
            <div class="card-body">
                <table class="table">
                    <thead>
                        <tr>
                            
                            <th scope="col">物種類別id</th>
                            <th scope="col">物種類別</th>
                            <th scope="col">物種id</th>
                            <th scope="col">物種名稱</th>
                            <th scope="col">學名</th>
                            <th scope="col">英文名</th>
                            <th scope="col">中文科名</th>
                            <th scope="col">英文科名</th>
                            <th scope="col">台灣保育等級</th>
                            <th scope="col">特有性</th>
                            <th scope="col">台灣地區遷徙屬性</th>
                            <th scope="col">馬祖地區遷徙屬性</th>
                            <th scope="col">金門地區遷徙屬性</th>
                            <th scope="col">東沙島遷徙屬性</th>
                            <th scope="col">已匯入</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(species,index) in speciesJsonData" :key="index"
                            :class="{'import_ok': species.id}"
                        >
                            <th scope="row">{{ species.species_category_id }}</th>
                            <td>{{ species.species_category_name }}</td>
                            <td>{{ species.id }}</td>
                            <td>{{ species.name }}</td>
                            <td>{{ species.scientificName }}</td>
                            <td>{{ species.englishName }}</td>
                            <td>{{ species.chineseFamilyName }}</td>
                            <td>{{ species.englishFamilyName }}</td>
                            <td>{{ species.conservationStatusTW }}</td>
                            <td>{{ species.endemism }}</td>
                            <td>{{ species.migratoryCharacteristicsTW }}</td>
                            <td>{{ species.migratoryCharacteristicsMatsu }}</td>
                            <td>{{ species.migratoryCharacteristicsKinmen }}</td>
                            <td>{{ species.migratoryCharacteristicsDongsha }}</td>
                            <td>{{ species.isImport }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
    
</template>
<script>
import * as XLSX from 'xlsx';
export default {
name:'intake-import',
props:{
    
},
data(){
    return {
        SpeciesCategoryList: [],
        speciesJsonData:[]
    }
},
methods:{
    async initView(){
        this.$store.state.loadingStatus = true
        const scRes = await this.$api.species.getSpeciesCategoryByName({
            name: '',
            columeName: 'create_time',
            orderby: 'DESC'
        });
        this.$store.state.loadingStatus = false
        if ( scRes.code !== 200){
            return alert('取得物種分類列表失敗')
        }
        this.SpeciesCategoryList = scRes.data
    },
    inputHandle(event){
        const file = event.target.files[0];
        try {
            // 使用 FileReader 讀取檔案
            const reader = new FileReader();
            reader.onload = async (e) => {
                this.readExcelDataToJsonData(e.target.result)
            };
            reader.readAsArrayBuffer(file);
        } catch (error) {
            console.error('讀取 Excel 檔案失敗:', error);
        }
    },
    async readExcelDataToJsonData(fileData){
        const data = new Uint8Array(fileData);
        this.workbook = XLSX.read(data, { type: 'array' });
        //匯入物種類別
        const speciesSheet = this.workbook.SheetNames[2];
        const speciesWorksheet = this.workbook.Sheets[speciesSheet];
        const speciesJsonData = XLSX.utils.sheet_to_json(speciesWorksheet, { header: 1 }); // header: 1 表示使用陣列格式
        console.log(`speciesJsonData:` , speciesJsonData)
        await this.importExcelSpeciesForm(speciesJsonData) 
    },
    async importExcelSpeciesForm(speciesJsonData){
        for (let index = 1; index < speciesJsonData.length; index++) {
            const species = speciesJsonData[index];
            console.log(`species=` , species)
            const species_category = this.SpeciesCategoryList.find(item=>item.name===species[1])
            //比對物種清單內的資料
            let data = {
                id: null,
                species_category_id: species_category ? species_category.id : `找不到${species[1]}`,
                species_category_name: species[1],
                name: species[3],
                scientificName: species[4],
                englishName: species[5],
                chineseFamilyName: species[6],
                englishFamilyName: species[7],
                subSpeciesName: '',
                conservationStatusTW: species[8],
                endemism: species[9],
                migratoryCharacteristicsTW: species[10],
                migratoryCharacteristicsMatsu: species[11],
                migratoryCharacteristicsKinmen: species[12],
                migratoryCharacteristicsDongsha: species[13],
                isImport: ''
            }
            
            const res = await this.createSpecies(data)
            if ( 
                res.code !== 200 &&
                res.code !== -2
            ){
                data.isImport(`[${res.code}]無法新增物種：${species[3]}`)
            }
            data.id = res.data.id
            
            this.speciesJsonData.push(data)
        }
        //先匯入物種類別，再匯入物種清單


    },
    async createSpecies(data){
        let objFrom = new FormData()
        objFrom.append('name',data.name)
        objFrom.append('species_category_id',data.species_category_id )
        objFrom.append('scientificName',data.scientificName )
        objFrom.append('englishName',data.englishName )
        objFrom.append('chineseFamilyName',data.chineseFamilyName )
        objFrom.append('englishFamilyName',data.englishFamilyName )
        objFrom.append('subSpeciesName',data.subSpeciesName )
        objFrom.append('conservationStatusTW',data.conservationStatusTW )
        objFrom.append('endemism',data.endemism )
        objFrom.append('migratoryCharacteristicsTW',data.migratoryCharacteristicsTW )
        objFrom.append('migratoryCharacteristicsMatsu',data.migratoryCharacteristicsMatsu )
        objFrom.append('migratoryCharacteristicsKinmen',data.migratoryCharacteristicsKinmen )
        objFrom.append('migratoryCharacteristicsDongsha',data.migratoryCharacteristicsDongsha )

        //開始呼叫API
        this.$store.state.loadingStatus = true
        const res = await this.$api.species.addSpecies(objFrom)
        this.$store.state.loadingStatus = false
        return res
    },
    excelDateToYMD(serial) {
        const utc_days = Math.floor(serial - 25569); // Excel 日期從 1900-01-01 起算，JS 從 1970-01-01 起算
        const utc_value = utc_days * 86400; // 換算成秒
        const date_info = new Date(utc_value * 1000); // 換算成毫秒

        const year = date_info.getUTCFullYear();
        const month = String(date_info.getUTCMonth() + 1).padStart(2, '0');
        const day = String(date_info.getUTCDate()).padStart(2, '0');

        return `${year}-${month}-${day}`;
    }
},
async mounted(){
   this.initView()
},
async created(){
    
}
};
</script>
<style scoped>
.import_ok{
    background-color: #ffc4c4;
}
</style>